"use client";

import { useTransition } from "react";
import { useLocale, useTranslations } from "next-intl";

import { locales, type Locale } from "@/shared/i18n/config";
import { usePathname, useRouter } from "@/shared/i18n/routing";

import GlobalIcon from "@/shared/icons/global.svg";

export const LanguageSwitcher = () => {
  const t = useTranslations("language");
  const locale = useLocale() as Locale;
  const pathname = usePathname();
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  /** Локалей две, но на случай третьей крутим список по кругу. */
  const nextLocale = locales[(locales.indexOf(locale) + 1) % locales.length];

  /**
   * `pathname` здесь уже без префикса локали, а `replace` подставит нужный:
   * `ru` останется на `/`, `en` уедет на `/en`.
   */
  const toggle = () =>
    startTransition(() => {
      router.replace(pathname, { locale: nextLocale });
    });

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={isPending}
      aria-label={t("label")}
      className="pressable inline-flex items-center gap-1.5 rounded-md py-2 text-sm leading-5 text-white outline-none hover:opacity-70 focus-visible:ring-3 focus-visible:ring-white/50 disabled:opacity-50"
    >
      <span className="uppercase">{locale}</span>
      <GlobalIcon className="size-4" />
    </button>
  );
};
